<template>
	<div class="tgju-widget-content full-padding">
		<slot v-if="widgetLoad">
			<div class="col-12 col-lg-12 col-xl-12 col-xxl-12">
				<div class="text-center p-2">
					<div class="widget-loading"></div>
				</div>
			</div>
		</slot>
		<slot v-else>
			<div class="row tgju-widgets-row" v-if="technicals.data.length">
				<div class="col-12 col-lg-6 col-xl-6 col-xxl-4" v-for="technical in technicals.data" :key="technical.id">
					<div class="tgju-widget light post mb-3">
						<div class="post-row">

							<div class="post-row-title-xl">
								<div class="post-row-title-content">
									<router-link class="h2" :to="{ name: 'ViewTechnical' , query: {tech_id: technical.id, tech_symbol: technical.market_symbol}}">
										{{ technical.title }}
									</router-link>
									<div class="post-row-title-tag">
										<span>
											{{ technical.market_symbol.toUpperCase() }}
										</span>
										<span>،1ماهه</span>
										<div class="l-tag green-tag">لانگ <i class="uil uil-arrow-up-left"></i></div>
									</div>
								</div>
							</div>
												
							<div class="tgju-widget-content profile-post-content pb-0">
								<div class="technical-image-post hover-popper" data-popper-type="user" data-popper-id="1">
									<slot v-if="$helpers.isJson(technical.image) && technical.image">
										<img :src="$helpers.api_url() + $helpers.json_pars(technical.image)[0].name">
									</slot>
									<slot v-else>
										<img src="/chart.png">
									</slot>
								</div>
								<div class="post-row-author">
									<img v-if="technical.user.avatar" :src="$helpers.api_url() + $helpers.json_pars(technical.user.avatar).name">
									<img v-else :src="'https://static.tgju.org/views/default/images/avatar.jpg'">

									<div class="user">
										<router-link :to="{ name: 'ProfileOthers' , params: { username: technical.user.username } }">
											{{ technical.user.firstname }} {{ technical.user.lastname }}
										</router-link>
										<div class="tag">
											{{ technical.market_title }}
										</div>
									</div>
									<div class="date">
										<!-- <i class="uil uil-clock"></i> -->
										{{ toRelative(technical.created_at) }}
									</div>
								</div>
								<div class="post-row-body">
									{{ technical.body }}
								</div>
							</div>

							<div class="post-btn-row comment-btn-row">

								<div class="post-btn-item post-btn-item-right">
									<i aria-hidden="true" class="uil uil-thumbs-up post-btn-icon pointer" @click="likeTechnical(technical.id)" :style="technical.is_like > 0 ? 'color: #e63946;' : ''"></i>
									<span class="post-btn-count"> 
										{{ technical.likes }}
									</span>
								</div>

								<div class="post-btn-grow">
								</div>

								<div class="post-btn-item">
									<i aria-hidden="true" class="uil uil-comment-alt-lines post-btn-icon pointer"></i>
									<span class="post-btn-count"> 
										{{ technical.comments }}
									</span>
								</div>
								<dropdown-menu class="dropdown-top" v-model="technical.showShare">
									<a href="#" class="post-btn-item dropdown-toggle" @click.prevent="">
										<i aria-hidden="true" class="uil uil-share-alt post-btn-icon pointer"></i>
									</a>

									<div slot="dropdown">
										<a class="dropdown-item" @click="shareTechnical('facebook',technical.title,technical.id,technical.market_symbol)"><i class="uil uil-facebook-f" aria-hidden="true"></i>اشتراک در فیسبوک</a>
										<a class="dropdown-item" @click="shareTechnical('twitter',technical.title,technical.id,technical.market_symbol)"><i class="uil uil-twitter-alt" aria-hidden="true"></i>اشتراک در تویتر</a>
										<a class="dropdown-item" @click="shareTechnical('telegram',technical.title,technical.id,technical.market_symbol)"><i class="uil uil-telegram-alt" aria-hidden="true"></i>اشتراک در تلگرام</a>
									</div>
								</dropdown-menu>
								
								<div class="post-btn-item">
									<i aria-hidden="true" class="uil uil-bookmark-full post-btn-icon pointer" @click="bookmarkTechnical(technical.id)" :style="technical.is_bookmark > 0 ? 'color: #e63946;' : ''"></i>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div v-else>
				<div class="row tgju-widgets-row">
					<div class="col-12 col-lg-12 col-xl-12 col-xxl-12">
						<div class="tgju-widget light post mb-3">
							<div class="no-content d-flex justify-content-center">
								<div class="text-center p-2">
									<div class="not-found-items">
										<i class="uil uil-chart"></i>
										<br>
										در این بخش تحلیلی به ثبت نرسیده است 
										<br>
										از قسمت ابزار تکنیکال اولین تحلیل خود را ثبت نمایید
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="technicals.last_page > 1" class="p-5 d-flex justify-content-center">
				<Paginate :page-count="technicals.last_page" :click-handler="getTechnical" :prev-text="'قبل'" :next-text="'بعد'" :container-class="'pagination'" ></Paginate>
			</div>
		</slot>
	</div>
</template> 


<style lang="scss" scoped>
	thead {
		display: table-header-group;
		vertical-align: middle;
		border-color: inherit;
	}
</style>

<script>
	import moment from "moment-jalaali";
	import Paginate from "vuejs-paginate";
	import DropdownMenu from '@innologica/vue-dropdown-menu';


	export default {
		name: 'ProfileOthersTechnical',
		components: {
			'dropdown-menu': DropdownMenu,
			Paginate
		},
		data: function () {
			return {
				technicals: [],
				widgetLoad: true,
				like_proccess: false,
				bookmark_proccess: false,
			}
		},
		mounted() {
			this.getTechnical();
		},
		methods: {
			toRelative(date) {
				if (moment().diff(moment(date), 'days') < 30)
					return moment(date).fromNow();
				else
					return moment(date).format("dddd jD jMMMM jYYYY / HH:mm");
			},
			getTechnical(page) {
				
				let api_data = {
					page : page ? page : 1,
					username: this.$route.params.username,
				};

				/**
				 * ارسال درخواست ای پی آی
				 */
				this.$helpers.makeRequest('GET', '/technical/my-list' , api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					var list = [];
					var newArray = api_response.data.response.technicals;
					newArray.data.forEach(e => {
						e["showShare"] = false;
						list.push(e);
					});
					newArray.data = list;

					this.technicals = newArray;
					
					this.widgetLoad = false;

				});
			},
			likeTechnical(id) {
				if ( this.like_proccess ) 
					return false;

				this.like_proccess = true;
				let index = this.$helpers.getIndex(this.technicals.data, id);
				
				var action = this.technicals.data[index].is_like > 0 ? 'unlike' : 'like';
				let api_data = {
					action: action
				};

				this.$helpers.makeRequest('GET', '/technical/like/' + id, api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						
						this.technicals.data[index].is_like = action == 'like' ? 1 : 0;
						
						action == 'like' 
							? this.technicals.data[index].likes++
							: this.technicals.data[index].likes--;
						
						this.like_proccess = false;
					}
				});
			},
			bookmarkTechnical(id) {
				if ( this.bookmark_proccess ) 
					return false;

				this.bookmark_proccess = true;
				let index = this.$helpers.getIndex(this.technicals.data, id);
				
				var action = this.technicals.data[index].is_bookmark > 0 ? 'remove' : 'add';
				let api_data = {
					action: action
				};

				this.$helpers.makeRequest('GET', '/technical/bookmark/' + id, api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						
						this.technicals.data[index].is_bookmark = action == 'add' ? 1 : 0;					
						this.bookmark_proccess = false;
					}
				});
			},
			shareTechnical(type,title,id,market_symbol) {
				this.$helpers.socialShare(type, title , process.env.VUE_APP_URL + '/technical/view?tech_id='+ id +'&tech_symbol=' + market_symbol )
			}
		},
	}
</script>